<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.71,7.29C13.71,7.29,8.71,2.29,8.71,2.29C8.530000000000001,2.11,8.280000000000001,2,8,2C7.72,2,7.47,2.11,7.29,2.29C7.29,2.29,2.29,7.29,2.29,7.29C2.11,7.47,2,7.72,2,8C2,8.55,2.45,9,3,9C3,9,5,9,5,9C5,9,5,13,5,13C5,13.55,5.45,14,6,14C6,14,10,14,10,14C10.55,14,11,13.55,11,13C11,13,11,9,11,9C11,9,13,9,13,9C13.55,9,14,8.55,14,8C14,7.72,13.89,7.47,13.71,7.29C13.71,7.29,13.71,7.29,13.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyShift',
} as DefineComponent
</script>
